import styled from 'styled-components';

interface RevisionItemStyledProps {
  selected?: boolean;
}

const RevisionItemStyled = styled.div<RevisionItemStyledProps>(
  ({ theme, selected }) => {
    return {
      color: selected ? theme.color.primary : theme.color.wfBlack,
      borderBottom: `1px solid ${theme.color.wfGrey200}`,
      userSelect: 'none',
      background: theme.color.wfWhite,
      justifyContent: 'flex-start',
      padding: `${theme.space[2]} ${theme.space[4]}`,
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      transition: 'background 0.1s linear',
      '&:hover': {
        background: theme.color.wfGrey50,
      },
    };
  },
);

const RevisionTextStyled = styled.span(({ theme }) => {
  return {
    marginRight: theme.space[2],
    fontSize: theme.font.size.small,
    color: 'inherit',
  };
});

export { RevisionItemStyled, RevisionTextStyled };
